export default "__VITE_ASSET__ClXqFGS8__"